import firebase from 'firebase';

// Initialize Firebase
const firebase_config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
};

firebase.initializeApp(firebase_config);

const db = firebase.firestore();
const {Timestamp} = firebase.firestore;

db.settings({
  timestampsInSnapshots: true,
});

const getCurrentUser = () => {
  const {currentUser} = firebase.auth();
  return currentUser;
}

const getCurrentUserId = () => {
  const currentUser = getCurrentUser();
  return currentUser ? currentUser.uid : null;
}

export {firebase, db, Timestamp, getCurrentUserId, getCurrentUser};



// WEBPACK FOOTER //
// ./src/firebase.js